import React, { useState, useEffect } from "react";
import bgLogin from "./images/Picture1.png";
import styles from "./css/SetupForm.module.css";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}
const TestLogin = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [loginData, setLoginData] = useState(false);
  const [msg, setMsg] = useState("");
  const location = useLocation();
  const [details, setDetails] = useState({
    outlet_title: "",
    user_mobile_number: "",
    area_pin: "",
  });
  console.log(location.pathname)
  const navigate = useNavigate();
  const { width } = useWindowDimensions();

  const RegisterLoginHandler = async () => {
    setIsLoading(true);
    const { outlet_title, user_mobile_number, area_pin } = details;
    if (outlet_title === "" || user_mobile_number === "" || area_pin === "") {
      setMsg("Please Enter All Field");
      setIsLoading(false);
      return;
    }
    let user_password = parseInt(Math.random() * 100000);
    let userName = outlet_title.replace(/\W/g, "");
    let user_name = userName;
    let i = 1;
    const login = () =>
      axios({
        method: "post",
        url: "https://api.myfooddo.com/new-registration",
        data: {
          area_pin,
          outlet_title,
          user_name,
          user_password,
          org_title: outlet_title,
          brand_name: outlet_title,
          user_mobile_number,
          url: 
          location.pathname,
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data.success) {
            setIsLoading(false);
            setLoginData({ user_name, user_password });
            sessionStorage.setItem("reg-website", 1);
          } else {
            user_name = `${userName}-${i}`;
            login();
            i++;
          }
        })
        .catch((err) => console.log(err));

    login(outlet_title);
  };

  return width >= 1000 ? (
    <div className="secondary_screen">
      <img src={bgLogin} alt="" style={{ width: "100%", height: "100%" }} />

      {!loginData ? (
        <div className="logoutPopup" style={{ left: "0px" }}>
          <div
            className={styles.formContainer}
            onKeyDown={(e) => (e.key === "Enter" ? RegisterLoginHandler() : "")}
          >
            <div
              className={styles.formGroup}
              style={{
                background: "white",
                width: "fit-content",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                padding: "1.5rem",
              }}
            >
              <div>
                <h3>Register here...</h3>
                <div className={styles.row} style={{ margin: "10px 0" }}>
                  <label className={styles.selectLabel}>
                    <input
                      type="text"
                      name="outlet_title"
                      className={styles.numberInput}
                      placeholder="Name of your outlet"
                      value={details.outlet_title}
                      id="outlet_title"
                      onChange={(e) =>
                        setDetails({ ...details, outlet_title: e.target.value })
                      }
                    />
                  </label>
                </div>
                <div className={styles.row} style={{ margin: "10px 0" }}>
                  <label className={styles.selectLabel}>
                    <input
                      type="text"
                      name="user_mobile_number"
                      className={styles.numberInput}
                      placeholder="Your Mobile Number"
                      value={details.user_mobile_number}
                      onChange={(e) =>
                        setDetails({
                          ...details,
                          user_mobile_number: e.target.value,
                        })
                      }
                    />
                  </label>
                </div>
                <div className={styles.row} style={{ margin: "10px 0" }}>
                  <label className={styles.selectLabel}>
                    <input
                      type="text"
                      name="area_pin"
                      className={styles.numberInput}
                      placeholder="Area ZIP/Postal Code"
                      value={details.area_pin}
                      onChange={(e) =>
                        setDetails({ ...details, area_pin: e.target.value })
                      }
                    />
                  </label>
                </div>
              </div>
              {msg !== "" ? <div style={{ color: "red" }}>{msg}</div> : ""}
              {!isLoading ? (
                <button
                  className={styles.submit}
                  onClick={RegisterLoginHandler}
                >
                  Sign Up
                </button>
              ) : (
                <button className={styles.submit} id="loading-screen">
                  <svg viewBox="0 0 100 100">
                    <path
                      d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                      fill="#ffffff"
                      stroke="none"
                    >
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        dur="1s"
                        repeatCount="indefinite"
                        keyTimes="0;1"
                        values="0 50 51;360 50 51"
                      ></animateTransform>
                    </path>
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div
          className="logoutPopup"
          style={{ left: "0px" }}
          onKeyDown={(e) =>
            e.key === "Enter"
              ? () => {
                  navigate("/login");
                }
              : document.getElementById().focus()
          }
        >
          <div className={styles.formContainer}>
            <div
              className={styles.formGroup}
              style={{
                background: "white",
                width: "fit-content",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                padding: "1.5rem",
              }}
            >
              <div>
                <h3 style={{ color: "red" }}>
                  Please Note Your
                  <br />
                  credentials for future login
                </h3>
                <div className={styles.row} style={{ margin: "10px 0" }}>
                  <label className={styles.selectLabel}>
                    User Name
                    <input
                      type="text"
                      name="outlet_title"
                      className={styles.numberInput}
                      placeholder="Name of your outlet"
                      value={loginData.user_name}
                    />
                  </label>
                </div>
                <div className={styles.row} style={{ margin: "10px 0" }}>
                  <label className={styles.selectLabel}>
                    Password
                    <input
                      type="text"
                      name="user_mobile_number"
                      className={styles.numberInput}
                      placeholder="Your Mobile Number"
                      value={loginData.user_password}
                    />
                  </label>
                </div>
                <i style={{ color: "red" }}>
                  Click a photo on your phone
                  <br />
                  Use <u style={{ color: "blue" }}> pos.myfooddo.com</u> to
                  login
                </i>
              </div>
              <button
                className={styles.submit}
                onClick={() => {
                  navigate("/login");
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  ) : !loginData ? (
    <div
      id="login-container"
      onKeyDown={(e) => (e.key === "Enter" ? RegisterLoginHandler() : "")}
    >
      {/* <div className="foodDoAdmin"><img src={foodDoAdmin} alt="" /></div> */}

      <div className="form" style={{ width: "90vw" }}>
        <h1>Register here...</h1>
        <div className="input-container" style={{ width: "100%" }}>
          <label htmlFor="username" className="form-label">
            Name of your outlet
          </label>
          <input
            type="username"
            className="form-input"
            name="username"
            placeholder=""
            value={details.outlet_title}
            id="outlet_title"
            onChange={(e) =>
              setDetails({ ...details, outlet_title: e.target.value })
            }
            autoComplete="off"
            required
          />
        </div>
        <div className="input-container" style={{ width: "100%" }}>
          <label htmlFor="username" className="form-label">
            Your Mobile Number
          </label>
          <input
            type="username"
            className="form-input"
            name="username"
            placeholder=""
            value={details.user_mobile_number}
            onChange={(e) =>
              setDetails({
                ...details,
                user_mobile_number: e.target.value,
              })
            }
            autoComplete="off"
            required
          />
        </div>
        <div className="input-container" style={{ width: "100%" }}>
          <label htmlFor="username" className="form-label">
            Area ZIP/Postal Code
          </label>
          <input
            type="username"
            className="form-input"
            name="username"
            placeholder=""
            value={details.area_pin}
            onChange={(e) =>
              setDetails({ ...details, area_pin: e.target.value })
            }
            autoComplete="off"
            required
          />
        </div>

        {!isLoading ? (
          <button className="submit-btn" onClick={RegisterLoginHandler}>
            Sign up
          </button>
        ) : (
          <button className="submit-btn" id="loading-screen">
            <svg viewBox="0 0 100 100">
              <path
                d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                fill="#ffffff"
                stroke="none"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  dur="1s"
                  repeatCount="indefinite"
                  keyTimes="0;1"
                  values="0 50 51;360 50 51"
                ></animateTransform>
              </path>
            </svg>
          </button>
        )}
      </div>
    </div>
  ) : (
    <div
      id="login-container"
      onKeyDown={(e) =>
        e.key === "Enter"
          ? () => {
              navigate("/login");
            }
          : document.getElementById().focus()
      }
    >
      {/* <div className="foodDoAdmin"><img src={foodDoAdmin} alt="" /></div> */}

      <div className="form" style={{ width: "90vw" }}>
        <h2 style={{ color: "red" }}>
          Please Note Your
          <br />
          credentials for future login
        </h2>
        <div className="input-container" style={{ width: "100%" }}>
          <label htmlFor="username" className="form-label">
            User Name
          </label>
          <input
            type="username"
            className="form-input"
            name="username"
            placeholder=""
            value={loginData.user_name}
            autoComplete="off"
          />
        </div>
        <div className="input-container" style={{ width: "100%" }}>
          <label htmlFor="username" className="form-label">
            Password
          </label>
          <input
            type="username"
            className="form-input"
            name="username"
            placeholder=""
            value={loginData.user_password}
            autoComplete="off"
          />
        </div>
        <i style={{ color: "red" }}>
          Click a photo on your phone
          <br />
          Use <u style={{ color: "blue" }}> pos.myfooddo.com</u> to login
        </i>

        <button
          className="submit-btn"
          onClick={() => {
            navigate("/login");
          }}
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default TestLogin;
